import SpendBenefits from 'features/spendBenefits/components/SpendBenefits';
import React from 'react';

export default function SpendBenefitsPage() {
  return <SpendBenefits />;
}
